import { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { Send } from "lucide-react";

export default function NewsletterForm({ variant = "default", buttonLabel = "Anmelden" }) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      setDone(true);
      setEmail("");
      toast.success("Du bist dabei – check dein Postfach!");
    } catch {
      toast.error("Anmeldung fehlgeschlagen");
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <div className="text-sm" data-testid="newsletter-done">
        🌿 Willkommen an Bord! Wir haben dir gerade eine Bestätigungs-Mail geschickt.
      </div>
    );
  }

  const dark = variant === "footer";

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2" data-testid="newsletter-form">
      <input
        required
        type="email"
        placeholder="deine@email.lu"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className={`flex-1 px-4 py-3 rounded-full text-sm focus:outline-none ${
          dark
            ? "bg-[rgba(245,240,232,0.1)] text-[var(--wp-cream)] placeholder-[rgba(245,240,232,0.5)] border border-[rgba(245,240,232,0.2)]"
            : "bg-white border"
        }`}
        style={!dark ? { borderColor: "var(--wp-border)" } : undefined}
        data-testid="newsletter-email"
      />
      <button disabled={sending} className={dark ? "btn-primary !bg-[var(--wp-cream)] !text-[var(--wp-primary)]" : "btn-primary"} data-testid="newsletter-submit">
        <Send className="w-4 h-4" /> {sending ? "…" : buttonLabel}
      </button>
    </form>
  );
}
